import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./store/store";
import AllRoutes from "./Admin-Dashboard/config/Routes";
import CustomSnackBar from "./Admin-Dashboard/@common/CustomSnackBar";
import { AuthProvider } from "@descope/react-sdk";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <AuthProvider
    projectId={
      process.env.REACT_APP_PROJECT_ID ? process.env.REACT_APP_PROJECT_ID : ""
    }
  >
    <Provider store={store}>
      <CustomSnackBar />
      <AllRoutes />
    </Provider>
  </AuthProvider>
);
